"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactFeather = require("react-feather");
var _helpers = require("../../utils/helpers");
var _FormModule = _interopRequireDefault(require("./../../scss/form-elements/Form.module.scss"));
function TextArea(props) {
  var _inputRef$current, _inputRef$current2, _inputRef$current3;
  const {
    name,
    label,
    rows,
    width,
    helpText,
    ...attributes
  } = props;
  const [inputClass, setInputClass] = (0, _react.useState)(`${_FormModule.default['form-field__input']}`);
  const inputRef = (0, _react.useRef)();
  const [validationMessage, setValidationMessage] = (0, _react.useState)('');
  const [validationStatus, setValidationStatus] = (0, _react.useState)('clean');
  const widthClass = `input-width--${width}`;
  const handleOnBlur = () => {
    setValidationStatus('touched');
    setInputClass(`${_FormModule.default['form-field__input']} ${_FormModule.default['input--touched']}`);
    if (inputRef.current.checkValidity()) {
      setValidationMessage('');
    } else {
      setValidationMessage(inputRef.current.validationMessage);
    }
  };
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: name,
    className: (0, _helpers.classes)([_FormModule.default['form-field'], _FormModule.default[widthClass]])
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _helpers.classes)([_FormModule.default['form-field__icon'], (_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && _inputRef$current.validity.valid ? '' : _FormModule.default['form-field__icon--invalid']])
  }, ((_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.checkValidity()) && validationStatus === 'touched' && /*#__PURE__*/_react.default.createElement(_reactFeather.CheckCircle, null), !((_inputRef$current3 = inputRef.current) !== null && _inputRef$current3 !== void 0 && _inputRef$current3.checkValidity()) && validationStatus === 'touched' && /*#__PURE__*/_react.default.createElement(_reactFeather.AlertTriangle, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: _FormModule.default['form-field__label']
  }, label, " ", /*#__PURE__*/_react.default.createElement("span", {
    className: _FormModule.default['form-field__label-help']
  }, helpText)), /*#__PURE__*/_react.default.createElement("textarea", (0, _extends2.default)({
    className: inputClass,
    name: name,
    id: name,
    rows: rows,
    onBlur: () => {
      handleOnBlur();
    },
    ref: inputRef
  }, attributes)), validationMessage !== '' && /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form-field__error-message']
  }, validationMessage));
}
var _default = exports.default = TextArea;